import { Workbox } from 'workbox-window';


declare global {
  interface Window {
    shared_worker: {
      saveTokens: (token: string, bmToken: string) => Promise<void>;
      getTokens: () => Promise<void>;
      clearTokens: () => Promise<void>;
      worker: SharedWorker;
    };
  }
}


export default function registerServiceWorker() {
  // Check if the serviceWorker Object exists in the navigator object ( means if browser supports SW )
  if ('serviceWorker' in navigator) {
    const wb = new Workbox('sw.js');

    wb.addEventListener('installed', event => {
      /**
       * We have the condition — event.isUpdate because we don’t want to show
       * this message on the very first service worker installation,
       * only on the updated
       */
      // TODO make communication between apps < - > SW to notify about new version
      if (event.isUpdate) {
        // alert('New version is available. Please refresh the page');
        console.info('application new version available');
        // window.location.reload();
      }
    });
    wb.register();
  }
}


export function registerSharedWorker() {
  if (!window.SharedWorker) {
    console.warn('SharedWorker не поддерживается в этом браузере');
    return;
  }

  try {
    window.shared_worker = {
      worker: new SharedWorker('shared-worker.js'),
      saveTokens: async (token, bmToken) => {
        return new Promise<void>((resolve) => {
          window.shared_worker.worker.port.postMessage({ type: 'SET_TOKENS', token, bmToken });
          resolve();
        });
      },
      getTokens: async () => {
        return new Promise<void>((resolve) => {
          window.shared_worker.worker.port.postMessage({ type: 'GET_TOKENS' });
          resolve();
        });
      },
      clearTokens: async () => {
        return new Promise<void>((resolve) => {
          window?.shared_worker?.worker?.port.postMessage({ type: 'CLEAR_TOKENS' });
          resolve();
        });
      },
    };

    window.shared_worker.worker.port.start();
  } catch (e) {
    console.error('❌ Ошибка в SharedWorker:', e);
  }
}